/**
 * Почему не включился микрофон — и что об этом сказать человеку.
 *
 * 🔴 ЗАЧЕМ ОТДЕЛЬНО. До 05.09.2026 отказ проглатывался: ученик жал «Включить
 * микрофон», ничего не происходило, объяснений не было. Это тот же тип поломки,
 * что был с озвучкой слова дня — «кнопка не работает», и человек решает, что
 * сломан телефон.
 *
 * ⚠️ РАЗБИРАЕМ ПО ВИДУ ОШИБКИ, А НЕ ОДНОЙ ФРАЗОЙ НА ВСЁ. «Разрешите микрофон»
 * бесполезно тому, у кого микрофон занят другим приложением, и вредно тому, у
 * кого его вовсе нет: человек лезет в настройки и не находит, что чинить.
 */
export type MicProblem = 'denied' | 'missing' | 'busy' | 'other';

export function micProblem(err: unknown): MicProblem {
  const name = (err as { name?: string })?.name ?? '';
  const text = `${name} ${(err as { message?: string })?.message ?? ''}`;

  // Отказано: человек нажал «Запретить», или запрет стоит с прошлого раза, или
  // администратор устройства закрыл микрофон.
  if (/NotAllowed|Permission|SecurityError/i.test(text)) return 'denied';
  // Устройства нет вовсе: настольный компьютер без микрофона.
  if (/NotFound|Overconstrained|DevicesNotFound/i.test(text)) return 'missing';
  // Занят: звонок в другом приложении, вторая вкладка с этой же комнатой.
  if (/NotReadable|TrackStart|AbortError/i.test(text)) return 'busy';
  return 'other';
}

/** Ключ подписи для каждого случая. Для отказа текст разный в приложении и в браузере. */
export function micProblemKey(problem: MicProblem, inApp: boolean): string {
  if (problem === 'denied') return inApp ? 'speakingRooms.micDeniedApp' : 'speakingRooms.micDeniedWeb';
  return `speakingRooms.mic${problem[0].toUpperCase()}${problem.slice(1)}`;
}
